import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'app-modal-error-enjoy-cl',
    templateUrl: './modal-error-enjoy-cl.component.html',
    styleUrls: ['./modal-error-enjoy-cl.component.scss']
})
export class ModalErrorEnjoyClComponent implements OnInit {

    @Input() title: string;
    @Input() closeBtnName: string;
    @Input() description: string;
    @Input() loading: any;
    @Input() name: any;
    constructor(public bsModalRef: BsModalRef,
    ) { }

    ngOnInit() {
    }

}
